<template>
  <div>
    <NavigationBar :tabs="tabs" :activeTab="activeTab" :actions="actions">
      <template v-slot:title>
        <div class="">
          <small
            class="grey--text font-weight-medium caption hidden-sm-and-down"
            >Datensatz bearbeiten</small
          >

          <div class="title text-h6 font-weight-medium">
            <span>
              {{ personnelRecord.firstName }}
              {{ personnelRecord.lastName }}
            </span>
          </div>
        </div>
      </template>
    </NavigationBar>
    <router-view :personnelRecord="personnelRecord" />
  </div>
</template>

<script>
import { db } from "@/firebase";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
// import Subheader from "@/components/_systemwide/Subheader.vue";
import {
  // MEMBER_MANAGEMENT_PERSONNEL_RECORDS_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_GENERAL_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CONTACT_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CHRONICLE_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CERTIFICATES_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_PHYSICALS_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_EMERGENCY_CONTACTS_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_ACCOUNTING_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_ATTENDANCE_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_YOUTH_GROUP_update,
} from "@/data/permission-types.js";

export default {
  name: "member-management-personnel-records-edit",
  components: {
    NavigationBar,
    // Subheader,
  },
  data() {
    return {
      activeTab: `general`,
      personnelRecord: {
        id: null,
        salutation: null,
        letterSalutation: null,
        title: null,
        firstName: null,
        lastName: null,
        birthday: null,
        birthdate: null,
        photoUrl: null,

        memberSince: null,
        memberUntil: null,
        dutyPosition: {
          badgeUrl: {
            size70x70: null,
            size125x125: null,
          },
          title: null,
          since: null,
        },
        rank: {
          badgeUrl: {
            size70x70: null,
            size125x125: null,
          },
          title: null,
          since: null,
        },
        status: null,
        division: null,
      },
      actions: [
        {
          title: "Bearbeitung verlassen",
          icon: "mdi-close-circle",
          actionStyle: "textBtnSubmit",
          color: "error",
          function: () => {
            this.$router.push({
              name: "member-management-personnel-records-details-general",
              params: {
                organizationId: this.$route.params.organizationId,
                itemId: this.$route.params.itemId,
              },
            });
          },
        },
      ],
    };
  },
  computed: {
    tabs() {
      const allTabs = [
        {
          id: 1,
          name: "Stammdaten",
          route: `general`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_GENERAL_update}`,
        },
        {
          id: 2,
          name: "Kontaktdaten",
          route: `contact`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CONTACT_update}`,
          // disabled: true,
        },
        {
          id: 3,
          name: "Chronik",
          route: `chronicle`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CHRONICLE_update}`,
          disabled: true,
        },
        {
          id: 4,
          name: "Anwesenheit",
          route: `attendances`,
          disabled: true,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_ATTENDANCE_update}`,
        },
        {
          id: 5,
          name: "Fristen",
          route: `deadlines`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CHRONICLE_update}`,
        },
        {
          id: 6,
          name: "Fertigkeiten",
          route: `certificates`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CERTIFICATES_update}`,
        },
        {
          id: 7,
          name: "Untersuchungen",
          route: `physicals`,
          disabled: true,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_PHYSICALS_update}`,
        },
        {
          id: 8,
          name: "Notfallkontakte",
          route: `emergency-contacts`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_EMERGENCY_CONTACTS_update}`,
          disabled: true,
        },
        { id: 11, name: "Inventar", route: `inventory`, disabled: true },
        {
          id: 12,
          name: "Abrechnung",
          route: `accounting`,
          disabled: true,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_ACCOUNTING_update}`,
        },
        {
          id: 13,
          name: "Jugendfeuerwehr",
          route: `youth-group`,
          collectionId: "personnelRecords_youthGroup",
          disabled: true,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_YOUTH_GROUP_update}`,
        },
        { id: 99, name: "Änderungshistorie", route: ``, disabled: true },
      ];
      return allTabs.filter((tab) => {
        return this.checkPermission(tab.permission);
      });
    },
  },
  created() {
    this.initialize();
  },
  watch: {
    $route: "initialize",
  },
  methods: {
    initialize() {
      this.getPersonnelRecord();
    },
    getPersonnelRecord() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("personnelRecords_general")
        .doc(this.$route.params.itemId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.personnelRecord = doc.data();
          } else {
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },
    checkPermission(item) {
      if (item == "" || item == undefined) {
        return true;
      } else {
        return this.$store.getters["organization/checkPermissionByID"](item);
      }
    },
  },
};
</script>

<style></style>
